@if (overlay$ | async; as overlay) {
  <div *transloco="let t" [ngClass]="overlay.level" class="overlay-container justify-content-center align-items-center">
    <div>
      @if(overlay.icon) {
        <div class="icon">
          <lucide-icon [img]="overlay.icon" [size]="96"></lucide-icon>
        </div>
      }
      <div>
        <div class="progress my-2" role="progressbar">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-secondary" style="width: 100%"></div>
        </div>
      </div>
      <p class="text-center">
        {{ overlay.message ?? t('layout.overlay.default.msg') }}
      </p>
    </div>
  </div>
}
